import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const CLOSE = 'close'
export const SURVEY_ADVANCED_SETTINGS = 'survey advanced settings'
export const DEFAULT_SWITCH = 'default switch'

export default {
  [PORTUGUESE]: {
    [CLOSE]: 'Fechar',
    [SURVEY_ADVANCED_SETTINGS]: 'Configurações Avançadas da Pesquisa',
    [DEFAULT_SWITCH]: 'não é um tipo válido',
  },

  [ENGLISH]: {
    [CLOSE]: 'Close',
    [SURVEY_ADVANCED_SETTINGS]: 'Survey Advanced Settings',
    [DEFAULT_SWITCH]: 'is not a valid type',
  },

  [SPANISH]: {
    [CLOSE]: 'Cerrar',
    [SURVEY_ADVANCED_SETTINGS]: 'Configuración Avanzada de la Encuesta',
    [DEFAULT_SWITCH]: 'no es un tipo valido',
  },
}
